import Phaser from 'phaser'
import { LAYER_HUD } from '../layers'

export default class GoalHint extends Phaser.GameObjects.Container {
  constructor (scene) {
    super(scene, 1100, 200)
    this.setDepth(LAYER_HUD)

    const bg = this.scene.add.image(30, 0, 'white').setTint(0).setDisplaySize(400, 240).setRotation(-0.08)
    this.add(bg)

    const bar = this.scene.add.image(130, 130, 'white').setTint(0).setDisplaySize(120, 20).setRotation(-0.08)
    this.add(bar)

    const icon = this.scene.add.image(-25, -60, 'hud', 'exclamation').setScale(0.8)
    this.add(icon)

    const text = this.scene.add.image(20, 30, 'hud', 'crash').setRotation(-0.03)
    this.add(text)

    this.setAlpha(0)

    this.stopping = false
    this.scene.player.on('scanning', () => {
      if (!this.stopping && this.scene.player.score >= 100) {
        this.stopping = true
        this.scene.tweens.add({
          duration: 100,
          targets: this,
          alpha: 0,
          onComplete: () => this.destroy()
        })
        return
      }
      if (this.stopping) {
        return
      }
      this.scene.tweens.add({
        duration: 300,
        targets: this,
        alpha: 1
      })
    })
    this.scene.player.on('backing', () => {
      if (this.stopping) {
        return
      }
      this.scene.tweens.add({
        duration: 100,
        targets: this,
        alpha: 0
      })
    })

    const resize = () => {
      if (this.scene) {
        this.x = 1100 + (this.scene.scale.width - 1280) / 2
      }
    }
    this.scene.scale.on('resize', resize)
    resize()
  }
}
